import * as React from 'react';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import { Grid } from '@material-ui/core';
import styles from "../../screens/team/team.module.css";
import ModalCloseButton from '../UI/ModalCloseButton';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 650,
    height: 250,
    bgcolor: 'background.paper',
    borderRadius: '5px',
    p: 4
};

export default function SupportModal(props) {
    const { setOpen, open } = props

    return (
        <div>
            <Modal
                open={open}
                onClose={() => setOpen(false)}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Grid container>
                        <Grid item md={12} style={{ display: "flex", justifyContent: "flex-end", marginTop: "-1rem" }}>
                            <ModalCloseButton onClick={() => setOpen(false)} style={{ position: "static" }} />
                        </Grid>
                        <Grid item md={12} style={{ display: "flex", justifyContent: "center", marginTop: "2.5rem" }}>
                            <p className={styles.SupporttModelText}>Contact <a href="https://oxiwear.com/" rel="noreferrer" target="_blank"><span style={{ color: "#0F9BB0", textDecorationLine: 'underline' }}>support@oxiwear.com</span></a> if you have any issues.</p>
                        </Grid>
                    </Grid>
                </Box>
            </Modal>
        </div>
    );
}